import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { services } from '../../data/services';
const LOGO = 'https://cdn.magicpatterns.com/uploads/9TVeR52UtqXcPBEydWX87j/image.png';
export function Footer() {
  return <footer className="bg-ink text-white/70" data-id="element-22" data-mp="2wi1p9atq8ix9">
      <div className="mx-auto max-w-7xl px-6 py-16" data-id="element-23" data-mp="31e8ka8kl4a0f">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_1fr_1fr]" data-id="element-24" data-mp="31gv1kzxa23vu">
          <div data-id="element-25" data-mp="3p5xj87rwvwqc">
            <div className="inline-flex rounded-xl bg-white p-3" data-id="element-26" data-mp="3p5e757oy02k8">
              <img src={LOGO} alt="Restored Services" className="h-12 w-auto" data-id="element-27" data-mp="3u2nwkncc0e82" />
            </div>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed" data-id="element-28" data-mp="3fdrr8y1ntfb5">
              We envision a world where every space reflects possibility, where
              homeowners trust their builders, and where together we create lasting
              impact — one project at a time.
            </p>
            <div className="mt-6 flex gap-3" data-id="element-29" data-mp="gpukiris1ie5">
              {[{
              icon: Instagram,
              label: 'Instagram'
            }, {
              icon: Facebook,
              label: 'Facebook'
            }, {
              icon: Linkedin,
              label: 'LinkedIn'
            }].map(social => <a key={social.label} href="#top" aria-label={social.label} className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand text-white transition-colors hover:bg-brand-dark" data-id="element-30" data-mp="3s7wgsgq1j9gy">
                  <social.icon className="h-4 w-4" aria-hidden="true" data-id="element-31" data-mp="11lkexvz6wvy" />
                </a>)}
            </div>
          </div>

          <nav aria-label="Services" data-id="element-32" data-mp="f0cwkera28hg">
            <h2 className="font-heading text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-33" data-mp="eza3q1ae9vyw">
              Services
            </h2>
            <ul className="mt-5 space-y-2.5 text-[15px]" data-id="element-34" data-mp="2grzezrx3sv2b">
              {services.map(service => <li key={service.id} data-id="element-35" data-mp="2crxp0g0qdq2v">
                  <a href="#services" className="transition-colors hover:text-brand-light" data-id="element-36" data-mp="2csyxqdu9y0hf">
                    {service.title}
                  </a>
                </li>)}
              <li data-id="element-37" data-mp="kq4pxdnvq94q">
                <a href="#honey-do" className="transition-colors hover:text-brand-light" data-id="element-38" data-mp="krp9k88no7nt">
                  Honey-Do List Special
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-39" data-mp="ulpkiqqmc74g">
            <h2 className="font-heading text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-40" data-mp="ypdufg2q3esv">
              Get in touch
            </h2>
            <ul className="mt-5 space-y-3.5 text-[15px]" data-id="element-41" data-mp="13nff25fsrm6g">
              <li data-id="element-42" data-mp="18f78qou9280t">
                <a href="tel:+17205550142" className="flex gap-3 transition-colors hover:text-brand-light" data-id="element-43" data-mp="18exdomuclao9">
                  <Phone className="mt-0.5 h-4 w-4 flex-none text-brand-light" aria-hidden="true" data-id="element-44" data-mp="1dd8nixkn7l6h" />
                  (720) 555-0142
                </a>
              </li>
              <li data-id="element-45" data-mp="1meozh9r3vvct">
                <a href="mailto:info@restoredservices.com" className="flex gap-3 transition-colors hover:text-brand-light" data-id="element-46" data-mp="1me6unoqdo8ta">
                  <Mail className="mt-0.5 h-4 w-4 flex-none text-brand-light" aria-hidden="true" data-id="element-47" data-mp="32vnnyieve9zg" />
                  info@restoredservices.com
                </a>
              </li>
              <li className="flex gap-3" data-id="element-48" data-mp="2xy5odimqt744">
                <MapPin className="mt-0.5 h-4 w-4 flex-none text-brand-light" aria-hidden="true" data-id="element-49" data-mp="2sy191vxkmifh" />
                Serving the Denver metro &amp; Front Range
              </li>
            </ul>
            <a href="#quote" className="mt-7 inline-flex rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-dark" data-id="element-50" data-mp="3lldl3c63v7uj">
              Book your free quote
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-sm text-white/45 sm:flex-row sm:items-center sm:justify-between" data-id="element-51" data-mp="d5ttehl31xhl">
          <p data-id="element-52" data-mp="8dsmlb6ooyyy">© {new Date().getFullYear()} Restored Services Colorado. All rights reserved.</p>
          <p data-id="element-53" data-mp="3p16ne787c7mb">Licensed &amp; insured · Restoring projects, places, and people.</p>
        </div>
      </div>
    </footer>;
}